import React, { useEffect, useState } from 'react'

import { Drawer, Button, Row, InputNumber } from 'antd'
import moment from 'moment'
import { useSelector } from 'react-redux'

import QuickDualDatePickers from '../shared/QuickDualDatePickers'
import { DEFAULT_DRAWER_WIDTH, TOOLTIP_LEFT } from '../utils/Constants'
import { getEndDateByType } from '../../../../utils/timePeriods'
import { BODY_STYLE } from '../allocation/AllocationForm'
import SearchCheckbox from '../../../antd/Selects/SearchCheckbox'
import IconTooltip from '../../../antd/Icons/IconTooltip'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { Quota } from '../../../../utils/entities/quota'

import '../../../../assets/quotas.scss'
import '../assets/places-definition.scss'

const TOOLTIP_TITLE = 'Define the total capacity of a care unit in terms of interns.'
const DRAWER_TITLE = 'Add free places'
const PLACES_TITLE = 'Places to add'
const SECTOR_TITLE = 'Care unit'
const SECTOR_KEY = 'name'

const PlacesFormDrawer = ({ date, period, sectors, visible, onClose, onQuotaAdding }) => {
  const t = useSelector(selectTranslate)

  const [startDate, setStartDate] = useState(moment())
  const [endDate, setEndDate] = useState(moment())
  const [localSectors, setLocalSectors] = useState([])
  const [places, setPlaces] = useState(0)

  useEffect(() => {
    if (date) {
      setStartDate(date)
      setEndDate(getEndDateByType(date, period.type))
    }
  }, [date, period])

  const createPlaces = () => {
    onQuotaAdding(localSectors.map(s => new Quota({ sector: { id: s.id }, total: places, startDate, endDate })))
    setLocalSectors([])
    setPlaces(0)
  }

  const handlePlacesAddition = places => {
    if (places === '') {
      setPlaces(0)
    }

    setPlaces(places)
  }

  const handleDatesChange = (dates, dateStrings) => {
    setStartDate(dates[0])
    setEndDate(dates[1])
  }

  const renderDrawerTitle = () => {
    return (
      <div className='places-creater-drawer-title'>
        <IconTooltip
          title={TOOLTIP_TITLE}
          placement={TOOLTIP_LEFT}
        />
        <h3 style={{ textAlign: 'center', margin: '0px' }}> {t(DRAWER_TITLE)} </h3>
      </div>
    )
  }

  const handleSectorChecked = (sector, checked) => {
    const newSector = checked
      ? [...localSectors, sector]
      : localSectors.filter(s => s.id !== sector.id)

    setLocalSectors(newSector)
  }

  return (
    <Drawer
      destroyOnClose
      title={renderDrawerTitle()}
      width={DEFAULT_DRAWER_WIDTH}
      onClose={onClose}
      visible={visible}
      bodyStyle={BODY_STYLE}
    >
      <div className='allocate-quota-form'>
        <Row>
          <h4>
            <b>
              {t('Date')}
            </b>
          </h4>
        </Row>
        <Row>
          <QuickDualDatePickers
            style={{ backgroundColor: 'white', justifyContent: 'left', padding: '0px' }}
            startDate={startDate}
            endDate={endDate}
            period={period}
            onDatesChange={handleDatesChange}
          />
        </Row>
        <Row>
          <h4>
            <b>
              {t(PLACES_TITLE)}
            </b>
          </h4>
        </Row>
        <Row>
          <InputNumber value={places} onChange={handlePlacesAddition} />
        </Row>
        <Row>
          <h4>
            <b>
              {t(SECTOR_TITLE)}
            </b>
          </h4>
        </Row>
        <Row>
          <div style={{ height: '200px' }}>
            <SearchCheckbox
              style={{ margin: '0' }}
              checkAllOption
              items={sectors}
              labelKey={SECTOR_KEY}
              values={localSectors}
              onCheck={handleSectorChecked}
              onCheckAll={setLocalSectors}
              valueKey='id'
            />
          </div>
        </Row>
      </div>
      <div style={{ height: '10px' }} />
      <Button
        onClick={createPlaces}
        disabled={localSectors.length === 0}
      >
        {t('Add places')}
      </Button>
    </Drawer>
  )
}

export default PlacesFormDrawer
